module.exports = __webpack_public_path__ + "img/egganimation.99afaa9a.gif";